import { render, staticRenderFns } from "./FormThemeControl.vue?vue&type=template&id=0355507b&scoped=true&"
import script from "./FormThemeControl.vue?vue&type=script&lang=js&"
export * from "./FormThemeControl.vue?vue&type=script&lang=js&"
import style0 from "./FormThemeControl.vue?vue&type=style&index=0&id=0355507b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0355507b",
  null
  
)

export default component.exports